import { request as c } from "@nextgen-web-framework/core";
import u from "../utils.js";
import { Projection as b } from "../models/Projection.js";
import { PaymentMethodId as y } from "../models/PaymentMethodId.js";
const d = "/compaymentas/v1", h = (e) => e + d, R = {
  get basePath() {
    return `${ApiConfigService.getBaseUrl()}/compaymentas/v1`;
  },
  /**
   *
   * @description - API Call to fetch transactions list
   *
   * @param filterOption Options that will be used to differentiate `AmPoint`, `AmPurse`, `Credit Voucher`
   * And sections `All`, `Redeemed`, `Received` and other's
   *
   * @returns List of Transactions.
   */
  // REMOVE THIS ANY WITH VALIDATE TYPE
  async getTransactionHistory(e, a, r) {
    const l = u({
      ...a,
      accountBalanceType: e
    });
    return await c.get({
      url: `${r != null && r.baseURL ? h(r.baseURL) : this.basePath}/account-balance-entries${l}`,
      ...(r == null ? void 0 : r.headers) && { headers: r == null ? void 0 : r.headers }
    });
  },
  /**
   * @description - TO BE USED IN FUTURE API Call to fetch Active Credit Vouchers of a User
   *
   * @returns List of Active Credit Voucher's
   */
  async getActiveCreditVouchers(e, a) {
    return await c.get({
      url: `${a != null && a.baseURL ? h(a.baseURL) : this.basePath}/credit-voucher?pageNumber=${e}`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  /**
   * @description - TO BE USED IN FUTURE API Call to fetch expiring AmPoints
   *
   * @returns List of expiring AmPoints
   */
  async getExpiringAmPoints(e) {
    const a = ApiConfigService.getBaseUrl();
    return await c.get({
      url: `${e != null && e.baseURL ? e.baseURL : a}/comloyaltypointsas/v1/expiring-loyalty-balance`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  /**
   * @description -API Call to fetch  AmPoints Balance
   *
   * @returns AmPoints Details
   */
  async getLoyalityBalance(e) {
    const a = ApiConfigService.getBaseUrl();
    return await c.get({
      url: `${e != null && e.baseURL ? e.baseURL : a}/comloyaltypointsas/v1/loyalty-balances`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  /**
   * @description -API Call to fetch  Ampurse Balance
   *
   * @returns Ampurse Details
   */
  async getAmpurseBalance(e) {
    return await c.get({
      url: `${e != null && e.baseURL ? h(e.baseURL) : this.basePath}/account-balances?accountType=${y.OnAccountBalance}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  /**
   * @description -API Call to fetch  Credit Vouchers Total
   *
   * @returns Credit Vouchers Total
   */
  async getCreditVouchersTotal(e) {
    return await c.get({
      url: `${e != null && e.baseURL ? h(e.baseURL) : this.basePath}/credit-voucher?projection=${b.Summary}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  }
};
export {
  R as InternalOptionsApi
};
//# sourceMappingURL=InternalOptionsApi.js.map
